import React from "react";
import ImgHeader from "../ImgHeader";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import { H1 } from "../Headers";
import SignUpCard from "../signup/SignUpCard";

export default () => {
  return (
    <>
      <ScrollToTopOnMount />
      <ImgHeader url="/static/img/support_v.2.png" shadowOpacity={0.5}>
        <H1>
          Let's figure this
          <br /> out, together.
        </H1>
      </ImgHeader>
      <SignUpCard image="/static/img/Card-RegisterToExplore.png" imageTitle="Signup" title="Sign up" cardMaxWidth="1000px" />
    </>
  );
};
